import { render, staticRenderFns } from "./GExamCreateMailSetting.vue?vue&type=template&id=a7cf2d4a&scoped=true&"
import script from "./GExamCreateMailSetting.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateMailSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GExamCreateMailSetting.vue?vue&type=style&index=0&id=a7cf2d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cf2d4a",
  null
  
)

export default component.exports